import { module as ModuleJS } from "modujs";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// Snapshot tailwind config with babel-plugin-preval
const tailwindScreens = preval`
    const resolveConfig = require('tailwindcss/resolveConfig');
    const tailwindConfig = require('./../../../tailwind.config.js');

    const fullConfig = resolveConfig(tailwindConfig)
    module.exports = fullConfig.theme.screens;
`;

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.parallaxItems = this.$("item");
        this.speed = this.getData("speed") || 1;
    }

    init() {
        gsap.utils.toArray(this.parallaxItems).forEach((item, i) => {
            const heightDiff = item.offsetHeight - this.el.offsetHeight;

            gsap.fromTo(
                item,
                {
                    y: -heightDiff,
                },
                {
                    scrollTrigger: {
                        trigger: this.el,
                        scrub: true,
                    },
                    y: 0,
                    ease: "none",
                }
            );

            ScrollTrigger.create({
                trigger: item,
                start: `top-=${heightDiff}px bottom`,
                end :`bottom+=${heightDiff}px top`,
                toggleClass: 'u-in-view'
            });
        });
    }

    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}
